'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const NewSlimSearchTicketFilled = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsxs(SvgIcon, _extends({
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M14.333 6.13V4.5a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v1.333A1.333 1.333 0 0 1 1 8.5v1.333a2 2 0 0 0 2 2h4.021a6 6 0 0 1-.143-.235c-1.381-2.391-.7-5.37 1.52-6.652 1.943-1.121 4.421-.573 5.935 1.183M5 9.5a.333.333 0 0 1-.667 0v-.667a.333.333 0 0 1 .667 0zm-.333-1.667C4.85 7.833 5 7.684 5 7.5v-.667a.333.333 0 0 0-.667 0V7.5c0 .184.15.333.334.333M5 5.5a.333.333 0 1 1-.667 0v-.667a.333.333 0 0 1 .667 0z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M13.709 11.414a3.792 3.792 0 1 0-.805.727l1.441 1.442a.542.542 0 0 0 .766-.766zm-2.917.286a2.708 2.708 0 1 0 0-5.417 2.708 2.708 0 0 0 0 5.417",
                clipRule: "evenodd"
            })
        ]
    })));

export { NewSlimSearchTicketFilled, NewSlimSearchTicketFilled as default };
//# sourceMappingURL=NewSlimSearchTicketFilled.js.map
